
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.676 37.014h-13.34a3.334 3.334 0 01-3.334-3.334V10.337a3.334 3.334 0 013.335-3.335h21.676a3.334 3.334 0 013.334 3.335V18.5M14.671 13.672h15.007M14.671 20.341h6.67M14.671 27.01h5.003","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.995 34.833h-2.33a.656.656 0 01-.665-.666v-2.33c0-.166.083-.332.166-.415l7.655-7.655c.25-.25.665-.25.915 0s.25.666 0 .916l-7.405 7.404v1.498h1.498l7.405-7.405c.25-.25.665-.25.915 0s.25.666 0 .915l-7.655 7.655c-.166 0-.332.083-.499.083z","fill":"#363636"}}),_c('path',{attrs:{"d":"M38.566 27.262a.636.636 0 01-.416-.166l-2.33-2.33a.636.636 0 01-.166-.416c0-.166.084-.332.167-.416l1.497-1.497a1.456 1.456 0 012.08 0l1.165 1.165a1.456 1.456 0 010 2.08l-1.497 1.497c-.167 0-.333.083-.5.083zm-1.497-2.995l1.497 1.498 1.082-1.082a.253.253 0 000-.333l-1.165-1.164a.253.253 0 00-.333 0l-1.081 1.081z","fill":"#363636"}})])
          )
        }
      }
    